<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                    <li>
                        <router-link to="/privacy-policy">
                            Privacy policy
                        </router-link>
                    </li>
                    <!--<li>
                        <router-link to="/about">
                            About Us
                        </router-link>
                    </li>-->
                    <li>
                        <a href="mailto:support@starttimerapp.com">
                            Contact Us
                        </a>
                    </li>
                    <li>
                        <a href="https://apps.apple.com/app/voice-sail-start-timer/id1492557181?mt=8">
                            <img src="/images/Download_on_the_App_Store.svg" alt="App Store"/>
                        </a>
                    </li>
                  <li>
                    <a class="d-block text-center" href='https://play.google.com/store/apps/details?id=info.leonenko.starttimer'>
                      <img style="height: 55px" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                    </a>
                  </li>
                </ul>
            </nav>
            <div class="copyright" style="height: 80px; line-height: 80px; margin: auto; display: inline-block">
                &copy; {{year}}, Egor Leonenko
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        props: {
            backgroundColor: String,
            type: String
        },
        data() {
            return {
                year: new Date().getFullYear()
            }
        }
    }
</script>
<style>
</style>
